import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";

/**
 * Champ mot de passe pour les formulaires de CRÉATION / ÉDITION d'utilisateur.
 *
 * Deux protections par rapport à un <Input type="password"> nu :
 *  1. `autoComplete="new-password"` par défaut → empêche le navigateur
 *     d'auto-remplir le champ avec le mot de passe enregistré de l'admin
 *     (bug : sinon le compte créé récupère silencieusement le mauvais mot de
 *     passe et devient injouable). NE PAS utiliser pour le formulaire de LOGIN,
 *     où l'auto-remplissage du mot de passe courant est au contraire souhaité.
 *  2. Bouton « œil » pour afficher/masquer → l'admin voit ce qui sera
 *     réellement enregistré (attrape une valeur parasite / un Caps Lock).
 *
 * Drop-in de <Input type="password" .../> : mêmes props (value, onChange,
 * placeholder, className, required, minLength, ...) sauf `type` géré en interne.
 */
const PasswordInput = React.forwardRef(
  ({ className = "", autoComplete = "new-password", ...props }, ref) => {
    const [visible, setVisible] = React.useState(false);
    return (
      <div className="relative">
        <Input
          ref={ref}
          type={visible ? "text" : "password"}
          autoComplete={autoComplete}
          className={`${className} pr-10`.trim()}
          {...props}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          title={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          className="absolute inset-y-0 right-0 flex items-center px-2.5 text-slate-400 hover:text-slate-200"
        >
          {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
    );
  }
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
